module.exports = __webpack_public_path__ + "static/img/recruit-img@t.b434e6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/recruit-img@t.png
// module id = lRcb
// module chunks = 0